<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <h1>科研实力</h1>
        <a class="tabs">
          <a class="tab-item active">
            <div class="tag"></div>
            实验与设备
          </a>
          <a href="#cooperation" class="tab-item">
            <div class="tag"></div>
            产学研合作
          </a>
          <a href="#patents" class="tab-item">
            <div class="tag"></div>
            专利与认证
          </a>
        </a>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">首页 > 科研实力</div>
    </div>

    <section class="section team" id="equipment">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">多个实验室平台 设备先进</div>
          <div class="tag"></div>
        </h2>
        <div class="card-grid">
          <div class="card_item">
            <div class="card card1">
              <div class="desc">微纳米粉体平台</div>
            </div>
            <div class="txt">
              拥有完善的微纳米粉体合成、改性设备及中试产线；致力于用化学方法在微纳米尺度可控合成各类无机材料，开发高重复、低成本、大规模制备无机微纳米材料的产业化路径。
            </div>
          </div>
          <div class="card_item">
            <div class="card card2">
              <div class="desc">电子浆料平台</div>
            </div>
            <div class="txt">
              拥有完善的光伏导电浆料检测设备、小试及中试放大技术，目前本实验室致力于研发光伏导电浆料，通过自有技术不断更新，已有较为成熟的光伏低温导电银浆、低温导电银包铜浆料
            </div>
          </div>
          <div class="card_item">
            <div class="card card3">
              <div class="desc">有机合成实验室</div>
            </div>
            <div class="txt">
              拥有完善的有机合成设备，拥有完善的有机合成小试，工艺研发以及中试放大的条件。致力于浆料所需添加剂的研发以及工业化生产条件摸索。
            </div>
          </div>
          <div class="card_item">
            <div class="card card4">
              <div class="desc">分析检测中心</div>
            </div>
            <div class="txt">
              拥有多台先进检测设备仪器，投资近千万元。重视质量管理及质量控制工作，各项规章制度健全，有明确的岗位责任制和完善的质量管理体系。
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section summary_pc" id="cooperation-rd" ref="summary_pc">
      <div class="section-container">
        <h2 class="title">汇聚顶尖人才 打造卓越科研能力</h2>
        <div class="numbers">
          <div class="number_item">
            <NumberCounter
              :target="10"
              suffix="%"
              :start-animation="summaryVisible"
            />
            <p>研发投入占营收比重</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="70"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>专利及认证数量</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="10"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>合作高校与科研机构</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="70"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>博士与硕士</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="3"
              suffix=""
              :start-animation="summaryVisible"
            />
            <p>参与制定国家标准</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="200"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>行业高精尖技术人才</p>
          </div>
        </div>
      </div>
    </section>

    <section
      class="section summary_mobile"
      id="cooperation-rd"
      ref="summary_mobile"
    >
      <div class="section-container">
        <h2 class="title">汇聚顶尖人才 打造卓越科研能力</h2>
        <div class="numbers">
          <div class="number_item">
            <NumberCounter
              :target="10"
              suffix="%"
              :start-animation="summaryVisible"
            />
            <p>研发投入占营收比重</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="70"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>专利及认证数量</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="10"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>合作高校与科研机构</p>
          </div>
        </div>
        <div class="numbers">
          <div class="number_item">
            <NumberCounter
              :target="70"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>博士与硕士</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="3"
              suffix=""
              :start-animation="summaryVisible"
            />
            <p>参与制定国家标准</p>
          </div>
          <div class="number_item">
            <NumberCounter
              :target="200"
              suffix="+"
              :start-animation="summaryVisible"
            />
            <p>行业高精尖技术人才</p>
          </div>
        </div>
      </div>
    </section>

    <div class="section school" data-aos="fade-up" data-aos-delay="200">
      <div class="section-container">
        <h3 class="title">知名高校和科研院所 产学研合作</h3>
        <p class="title_desc">
          公司注重产学研合作以及产业链上下游合作，与多所知名高校和科研院所开展产学研合作项目
        </p>

        <div class="shool_pc">
          <HorizontalScrollInterval :items="schoolImages" :gap="45">
            <template v-slot="{ index, item }">
              <div class="partner-logo">
                <img :src="item" alt="" />
              </div>
            </template>
          </HorizontalScrollInterval>
        </div>

        <div class="school_mobile">
          <HorizontalScrollInterval :items="schoolImages" :gap="37">
            <template v-slot="{ index, item }">
              <div class="partner-logo">
                <img :src="item" alt="" />
              </div>
            </template>
          </HorizontalScrollInterval>
        </div>
      </div>
    </div>

    <section class="section patent" id="patents">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">多项专利与认证 参与行业标准制定</div>
          <div class="tag"></div>
        </h2>

        <div class="patent_pc">
          <HorizontalScrollIntervalPro
            :visibleCount="5"
            :wrapperHeight="400"
            :items="patentImages"
            :itemWidth="186"
            :itemHeight="264"
            :paddingX="0"
            :gap="97"
            :activeScale="1.5"
            :stepInterval="4000"
          >
            <template v-slot="{ index, item }">
              <img
                :src="item"
                alt=""
                style="height: 100%; object-fit: contain"
              />
            </template>
          </HorizontalScrollIntervalPro>
        </div>

        <div class="patent_mobile">
          <el-carousel
            ref="stepCarousel"
            :interval="5000"
            arrow="always"
            height="364px"
            indicator-position="none"
            :autoplay="true"
          >
            <el-carousel-item v-for="item in patentImages" :key="item">
              <div class="custom">
                <img :src="item" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="product_details">
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">
                银包铜粉、制备方法、在银包铜浆料中的应用及检测银包铜粉中银包覆层致密性的方法
              </div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种银包铜粉中氯离子含量的测定方法</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">亚微米级单晶铜粉的制备方法</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种微纳米银粉及其制备方法和应用</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种棘状球形纳米镍粉的制备方法</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种微米铜粉的制备方法及其应用</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种导电浆料中铜含量的检测方法</div>
            </div>
          </div>
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">
                一种环氧化物诱导下制备球状纳米银粉的方法及纳米银粉
              </div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种微纳米银粉及其制备方法和应用</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种银粉的制备装置</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种金属微粉的筛分设备</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种银包铜粉的制备装置</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">一种金属微粉收集过滤装置</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">......</div>
            </div>
          </div>
          <div class="detail_item">
            <div class="line">
              <div class="dot"></div>
              <div class="txt">
                <span>参编1项国家标准：</span>
                GB/T
                45945-2025《家用和类似用途电器中功能材料测试与评价指南》制定
              </div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">
                <span>参编2项团体标准</span>
              </div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">
                <span>参与承担工信部高质量发展专项1项</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import NumberCounter from "../components/NumberCounter.vue";
import HorizontalScroll from "../components/HorizontalScroll.vue";
import HorizontalScrollInterval from "../components/HorizontalScrollInterval.vue";
import HorizontalScrollIntervalPro from "../components/HorizontalScrollIntervalPro.vue";
import { RDAPI } from "../api/api";
import { imgBaseUrl } from "../api/config";
export default {
  name: "Rd",
  components: {
    Header,
    Footer,
    NumberCounter,
    HorizontalScroll,
    HorizontalScrollInterval,
    HorizontalScrollIntervalPro,
  },

  computed: {
    // schoolImages() {
    //   const images = [
    //     require("@/static/school/school1.jpg"),
    //     require("@/static/school/school2.jpg"),
    //     require("@/static/school/school3.jpg"),
    //     require("@/static/school/school4.jpg"),
    //     require("@/static/school/school5.jpg"),
    //     require("@/static/school/school6.jpg"),
    //     require("@/static/school/school7.jpg"),
    //   ];
    //   return [...images]; // 使用展开运算符创建新数组
    // },

    // patentImages() {
    //   const images = [
    //     require("@/static/patents/patent_1.jpg"),
    //     require("@/static/patents/patent_2.jpg"),
    //     require("@/static/patents/patent_3.jpg"),
    //     require("@/static/patents/patent_4.jpg"),
    //     require("@/static/patents/patent_5.jpg"),
    //     require("@/static/patents/patent_6.jpg"),
    //     require("@/static/patents/patent_7.jpg"),
    //     require("@/static/patents/patent_8.jpg"),
    //     require("@/static/patents/patent_9.jpg"),
    //     require("@/static/patents/patent_10.jpg"),
    //     require("@/static/patents/patent_11.jpg"),
    //     require("@/static/patents/patent_12.jpg"),
    //     require("@/static/patents/patent_13.jpg"),
    //   ];
    //   return [...images];
    // },
  },
  data() {
    return {
      schoolImages: [],
      patentImages: [],

      honorPre: "",
      honorNext: "",
      honorPrePre: "",
      honorNextNext: "",
      // 为每张图片添加独立key，确保过渡动画正常触发
      honorPrePreKey: 0,
      honorPreKey: 1,
      honorNextKey: 2,
      honorNextNextKey: 3,
      summaryVisible: false, // 数字滚动触发状态
    };
  },
  created() {
    // 高校和荣誉图片列表
    RDAPI.getAllResearchData().then((res) => {
      console.log("数据", res);
      const { famousUniversities, patentCertifications } = res;
      this.schoolImages = famousUniversities.map((item) => `${imgBaseUrl}${item.imageUrl}`);
      this.patentImages = patentCertifications.map((item) => `${imgBaseUrl}${item.imageUrl}`);
    });
  },
  mounted() {
    // 获取临近选项
    this.getNeighbors(0);
    // 初始化数字滚动监听
    this.setupSectionObserver();
  },

  methods: {
    // 数字滚动监听方法
    setupSectionObserver() {
      const options = {
        root: null,
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      };

      this.sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.summaryVisible = true;
            this.sectionObserver.unobserve(entry.target);
          }
        });
      }, options);

      if (this.$refs.summary_pc) {
        this.sectionObserver.observe(this.$refs.summary_pc);
      }
      if (this.$refs.summary_mobile) {
        this.sectionObserver.observe(this.$refs.summary_mobile);
      }
    },
    getNeighbors(index) {
      const arr = [...this.patentImages];
      const length = arr.length;

      if (length === 0)
        return {
          prevItems: [],
          current: null,
          nextItems: [],
        };

      if (length === 1) {
        this.honorPrePre = arr[0];
        this.honorPre = arr[0];
        this.honorNext = arr[0];
        this.honorNextNext = arr[0];
        this.updateImageKeys();
        return;
      }

      if (length === 2) {
        // 只有2个元素时特殊处理
        const otherIndex = index === 0 ? 1 : 0;
        this.honorPrePre = arr[otherIndex];
        this.honorPre = arr[index];
        this.honorNext = arr[otherIndex];
        this.honorNextNext = arr[index];
        this.updateImageKeys();
        return;
      }

      // 获取前2项的索引（支持循环）
      const prevIndices = [
        index === 0 ? length - 2 : index === 1 ? length - 1 : index - 2,
        index === 0 ? length - 1 : index - 1,
      ];

      // 获取后2项的索引（支持循环）
      const nextIndices = [
        index === length - 1 ? 0 : index + 1,
        index === length - 2 ? 0 : index === length - 1 ? 1 : index + 2,
      ];

      // 根据需求更新数据
      this.honorPre = arr[prevIndices[1]]; // 最近的前一项
      this.honorPrePre = arr[prevIndices[0]]; // 更远的前一项
      this.honorNext = arr[nextIndices[0]]; // 最近的后一项
      this.honorNextNext = arr[nextIndices[1]]; // 更远的后一项

      // 更新key触发过渡动画
      this.updateImageKeys();
    },
    // 更新所有图片的key，确保transition生效
    updateImageKeys() {
      this.honorPrePreKey += 1;
      this.honorPreKey += 1;
      this.honorNextKey += 1;
      this.honorNextNextKey += 1;
    },
    honorChange(index) {
      console.log(999, index);
      this.getNeighbors(index);
    },
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    padding: 100px 0;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/rd/head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      h1 {
        margin-top: 275px;
        font-size: 48px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;
          text-decoration: none;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 40px !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
  }

  .team {
    padding-top: 70px;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 72px;

      .txt {
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }

      .tag {
        margin-top: 24px;
        width: 24px;
        height: 3px;
        background: #0248ff;
      }
    }

    .card-grid {
      display: flex;
      align-self: center;
      gap: 27px;

      .card_item {
        flex: 1;
        border-radius: 8px;
        overflow: hidden;

        .card {
          position: relative;
          margin-bottom: 20px;
          width: 310px;
          height: 440px;
          // padding-top: 142.4%;
          border-radius: 8px;
          overflow: hidden;

          .desc {
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 80px;
            line-height: 80px;
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            font-size: 20px;
          }
        }
        .card:hover {
          transform: scale(1.01);
        }
        .card1 {
          background: url("../static/rd/laboratory_item1.png") center/cover
            no-repeat;
        }

        .card2 {
          background: url("../static/rd/laboratory_item2.png") center/cover
            no-repeat;
        }

        .card3 {
          background: url("../static/rd/laboratory_item3.png") center/cover
            no-repeat;
        }

        .card4 {
          background: url("../static/rd/laboratory_item4.png") center/cover
            no-repeat;
        }

        .txt {
          padding: 0 12px;
          font-size: 14px;
          color: #888888;
          line-height: 26px;
        }
      }
    }
  }

  .summary_pc {
    padding-top: 70px !important;
    background: linear-gradient(to bottom, #d4e1fe, #ebf2fe);

    .title {
      text-align: center;
      font-weight: 600;
      font-size: 40px;
      color: #363636;
    }

    .numbers {
      margin-top: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .number-counter {
        font-weight: 500;
        font-size: 80px;
        color: #0248ff;
        margin-bottom: 10px;
      }

      p {
        white-space: nowrap;
        font-weight: 400;
        font-size: 16px;
        color: #9e9e9e;
      }
    }
  }

  .summary_mobile {
    display: none;
  }

  .school {
    .title {
      margin-bottom: 27px;
      text-align: center;
      font-weight: 600;
      font-size: 40px;
      color: #363636;
    }

    .title_desc {
      margin-bottom: 60px;
      text-align: center;
      font-size: 16px;
      color: #808080;
    }

    .shool_pc {
      display: block;
    }
    .school_mobile {
      display: none;
    }
  }

  .patent {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 72px;

      .txt {
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }

      .tag {
        margin-top: 24px;
        width: 24px;
        height: 3px;
        background: #0248ff;
      }
    }

    .custom_carousel {
      display: flex;
      align-items: center;

      .left,
      .right {
        width: 424px;
        display: flex;
        gap: 52px;
        height: 264px;
        align-items: center;
        justify-content: center;

        // 为每张图片添加独立容器，确保过渡范围正确
        .img-wrapper {
          height: 100%;
          position: relative;
          overflow: hidden; // 约束图片过渡范围，防止溢出
          flex-shrink: 0; // 避免图片容器被压缩

          img {
            height: 100%;
            width: auto;
            position: relative; // 锁定图片尺寸，避免突变
          }
        }
      }

      .middle {
        flex: 1;
      }
    }

    .partner_logo {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        object-fit: contain;
      }
    }

    .patent_pc {
      display: block;
    }

    .patent_mobile {
      display: none;
    }

    .product_details {
      margin-top: 72px;
      display: flex;
      gap: 63px;

      .detail_item {
        flex: 1;

        .line {
          display: flex;
          align-items: flex-start;

          .dot {
            margin-top: 10px;
            flex-shrink: 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: #888;
            margin-right: 8px;
          }

          .txt {
            font-size: 14px;
            color: #888888;
            line-height: 26px;

            span {
              font-weight: 600;
              color: #0248ff;
            }
          }
        }
      }
    }
  }
  .patent {
    /deep/.scroll-right-btn {
      right: 456px;
    }
    /deep/.scroll-left-btn {
      left: 456px;
    }
    //  调整放大的那个前面一个  后面一个元素的位置  防止放大元素与他们的间距太小
    /deep/.prev-item {
      position: relative;
      left: -45px;
    }
    /deep/.next-item {
      position: relative;
      right: -45px;
    }
  }

  .number_item {
    text-align: center;
    min-width: 145px;
  }
}
// mobile
@media (max-width: 750px) {
  .section {
    padding: 50px 0;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    // background: url("../static/rd/head_bg.png");
    // background-size: 100% 100%;
    background: url("../static/rd/head_bg.png") center/cover no-repeat;

    .hero-overlay {
      padding-top: 55px;

      h1 {
        line-height: 174px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
      }

      .tabs {
        display: none !important;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;
          text-decoration: none;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
  }

  .team {
    padding-top: 20px;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 36px;

      .txt {
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }

      .tag {
        margin-top: 12px;
        width: 12px;
        height: 2px;
        background: #0248ff;
      }
    }

    .card-grid {
      display: grid;
      align-self: center;
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
      gap: 13px;

      .card_item {
        flex: 1;
        border-radius: 8px;
        overflow: hidden;

        .card {
          position: relative;
          margin-bottom: 15px;
          width: 155px;
          height: 220px;
          // padding-top: 142.4%;
          border-radius: 4px;
          overflow: hidden;

          .desc {
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            font-size: 12px;
          }
        }
        .card1 {
          background: url("../static/rd/laboratory_item1.png") center/cover
            no-repeat;
        }

        .card2 {
          background: url("../static/rd/laboratory_item2.png") center/cover
            no-repeat;
        }

        .card3 {
          background: url("../static/rd/laboratory_item3.png") center/cover
            no-repeat;
        }

        .card4 {
          background: url("../static/rd/laboratory_item4.png") center/cover
            no-repeat;
        }

        .txt {
          padding: 0 12px;
          font-size: 12px;
          color: #888888;
          line-height: 18px;
          text-align: justify;
        }
      }
    }
  }

  .summary_pc {
    display: none;
  }

  .summary_mobile {
    padding-top: 35px !important;
    background: linear-gradient(to bottom, #d4e1fe, #ebf2fe);

    .title {
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      color: #363636;
    }

    .number_item {
      width: 0;
      flex: 1;
      overflow: hidden;
      text-align: center;
      min-width: 75px;
    }

    .numbers {
      margin-top: 30px;
      width: 100%;
      display: flex;
      align-items: center;

      .number-counter {
        font-weight: 500;
        font-size: 40px;
        color: #0248ff;
        margin-bottom: 10px;
      }

      p {
        white-space: nowrap;
        font-weight: 400;
        font-size: 12px;
        color: #9e9e9e;
      }
    }
  }

  .school {
    .title {
      margin-bottom: 13px;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      color: #363636;
    }

    .title_desc {
      margin-bottom: 30px;
      text-align: center;
      font-size: 12px;
      color: #808080;
    }

    // /deep/.horizontal-scroll-container {
    //   padding-left: 24px !important;
    //   padding-right: 24px !important;
    // }

    .shool_pc {
      display: none;
    }
    .school_mobile {
      display: block;
      /deep/.horizontal-scroll-container {
        padding-left: 22px !important;
        padding-right: 22px !important;
        .scroll-left-btn {
          left: -12px;
          width: 24px;
          height: 24px;
          color: #0248ff;
          background: rgba(236, 241, 255, 1);
        }
        .scroll-right-btn {
          right: -12px;
          width: 24px;
          height: 24px;
          color: #0248ff;
          background: rgba(236, 241, 255, 1);
        }
      }
    }

    .partner-logo {
      img {
        width: 70px;
        height: 70px;
      }
    }

    /deep/.el-carousel__arrow--left {
      left: 0;
      width: 24px;
      height: 24px;
      color: #0248ff;
      background: rgba(236, 241, 255, 1);
    }
    /deep/.el-carousel__arrow--right {
      right: 0;
      width: 24px;
      height: 24px;
      color: #0248ff;
      background: rgba(236, 241, 255, 1);
    }
  }

  .patent {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 36px;

      .txt {
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }

      .tag {
        margin-top: 12px;
        width: 12px;
        height: 2px;
        background: #0248ff;
      }
    }

    .custom_carousel {
      display: flex;
      align-items: center;

      .left,
      .right {
        width: 424px;
        display: flex;
        gap: 52px;
        height: 264px;
        align-items: center;
        justify-content: center;

        // 为每张图片添加独立容器，确保过渡范围正确
        .img-wrapper {
          height: 100%;
          position: relative;
          overflow: hidden; // 约束图片过渡范围，防止溢出
          flex-shrink: 0; // 避免图片容器被压缩

          img {
            height: 100%;
            width: auto;
            position: relative; // 锁定图片尺寸，避免突变
          }
        }
      }

      .middle {
        flex: 1;
      }
    }

    .partner_logo {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        object-fit: contain;
      }
    }

    .patent_pc {
      display: none;
    }

    .patent_mobile {
      display: block;
      .custom {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      /deep/.el-carousel__arrow--left {
        left: 0;
        width: 24px;
        height: 24px;
        color: #0248ff;
        background: rgba(236, 241, 255, 1);
      }
      /deep/.el-carousel__arrow--right {
        right: 0;
        width: 24px;
        height: 24px;
        color: #0248ff;
        background: rgba(236, 241, 255, 1);
      }
    }

    .product_details {
      margin-top: 72px;
      display: flex;
      flex-direction: column;
      gap: 0px;

      .detail_item {
        flex: 1;

        .line {
          display: flex;
          align-items: flex-start;

          .dot {
            margin-top: 10px;
            flex-shrink: 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: #888;
            margin-right: 8px;
          }

          .txt {
            font-size: 14px;
            color: #888888;
            line-height: 26px;

            span {
              font-weight: 600;
              color: #0248ff;
            }
          }
        }
      }
    }
  }
  .patent {
    /deep/.scroll-right-btn {
      right: 0px;
    }
    /deep/.scroll-left-btn {
      left: 0px;
    }
    //  调整放大的那个前面一个  后面一个元素的位置  防止放大元素与他们的间距太小
    /deep/.prev-item {
      position: relative;
      left: -45px;
    }
    /deep/.next-item {
      position: relative;
      right: -45px;
    }
  }
}
</style>
